export class ExcelValidationError extends Error {
  private readonly sheet?: string;
  private readonly rowNum?: number;

  constructor(message: string, worksheet?: string, rowNum?: number) {
    super(message);
    this.sheet = worksheet;
    this.rowNum = rowNum;
  }

  toString() {
    return this.message + (this.sheet ? ` from sheet ${this.sheet}` : "") + (this.rowNum ? ` at row ${this.rowNum}` : "");
  }
}

export const NoSheetExistsError = (worksheet: string) =>
  new ExcelValidationError(`No sheet exists with name: ${worksheet}`);
